import React from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import Turnstile from 'react-turnstile';

export default function TurnstileWidget({ onVerify, siteKey }) {
  // Only render on web platform to prevent native bundling issues
  if (Platform.OS !== 'web') {
    return null; 
  }

  return (
    <View style={styles.container}>
      <Turnstile
        sitekey={siteKey}
        onVerify={(token) => {
          onVerify(token);
        }}
        onError={() => {
          console.log('Turnstile challenge failed');
        }}
        onExpire={() => {
          console.log('Turnstile token expired');
        }}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginVertical: 10,
    alignItems: 'center',
  },
});